import { Link } from 'react-router-dom';
import { ICandidateFilter, ILeadSearchFilter, IPostgreJobsAnalyticsPayload } from 'wisestep-api';
import { WsColors } from 'wisestep-base';

import getEncodedQueryParams from '../../../../utils/getEncodedQueryParams';
import { getDateRangeByTimePeriod } from '../../utils/timeInfo';
import { overrideAnalyticsFilter } from '../helper';
import { overrideQueryFilter } from '../jobs/utils/jobsHelper';

function mapAnalyticsToLeadFilter(
  analyticsFilters: ICandidateFilter[],
  query: IPostgreJobsAnalyticsPayload
): ILeadSearchFilter {
  const leadSearchFilter = {} as ILeadSearchFilter;
  leadSearchFilter.searchAcross = [];

  overrideQueryFilter(query.filters ?? [], analyticsFilters).forEach((analyticsFilter) => {
    const filterValues = (analyticsFilter.values ?? []) as string[];
    if (filterValues.length == 0) return;

    switch (analyticsFilter.filterName.toUpperCase()) {
      case 'DATE_RANGE': {
        const values = JSON.parse(filterValues[0] as string);
        values.fromDate && (leadSearchFilter.fromDate = new Date(values.fromDate).toISOString());
        values.toDate && (leadSearchFilter.toDate = new Date(values.toDate).toISOString());
        break;
      }
      case 'RECRUITER_ID':
        leadSearchFilter.createdByIds = filterValues;
        break;
      case 'RECRUITER_ID_OWNER':
        leadSearchFilter.leadOwners = filterValues;
        break;
      case 'METRIC_OWNED':
      case 'METRIC_OWNED_BY_STATUS':
      case 'TABLE_OWNED':
      case 'TABLE_OWNED_BY_STATUS':
        leadSearchFilter.leadOwned = filterValues[0] as string;
        break;
      case 'METRIC_UPDATED_BY_STATUS':
        leadSearchFilter.leadUpdated = filterValues[0] as string;
        break;
      case 'LEAD_STATUS_ID':
        leadSearchFilter.status = filterValues;
    }
  });

  if (!leadSearchFilter.fromDate && !leadSearchFilter.toDate) {
    const dateTime = getDateRangeByTimePeriod(query.range as string);
    leadSearchFilter.fromDate = new Date(dateTime.fromDateTime).toISOString();
    leadSearchFilter.toDate = new Date(dateTime.toDateTime).toISOString();
  }

  switch (query.scope?.toUpperCase()) {
    case 'WORKSPACE':
      leadSearchFilter.searchAcross.push('ACROSS_WORKSPACE');
      break;
    case 'LOGGEDINUSER':
      leadSearchFilter.searchAcross.push('MY_PERSONAL_DATA');
  }
  return leadSearchFilter;
}

function getEncodedLeadFilters(analyticsFilter, query) {
  return getEncodedQueryParams({
    ...mapAnalyticsToLeadFilter(analyticsFilter, query),
    source: [],
    businessUnitIds: [],
    orgUnitIds: [],
    tags: [],
    clientIds: [],
    contactIds: [],
    query: '',
    workspaceId: '',
    page: 0,
    size: 25,
    sortOrder: 'asc',
    sortBy: 'createdOn',
    filterByDateType: 'createdOn',
    clientOperator: 'is',
    contactOperator: 'is',
    createdByOperator: 'is',
    sourceOperator: 'is',
    tagsOperator: 'is',
    leadOwnersOperator: 'is',
  });
}

export const renderLeadCountCell = (
  params,
  filterNameValuePairs: [string, string][],
  analyticsFilter: any[],
  query: IPostgreJobsAnalyticsPayload
) => {
  const overridenFilters = overrideAnalyticsFilter(analyticsFilter, filterNameValuePairs);

  return (
    <Link
      to={`/leads/?d=${getEncodedLeadFilters(overridenFilters, query)}`}
      target="_blank"
      style={{
        textDecoration: 'none',
        color: WsColors.TheBlues700,
      }}
    >
      {params.value}
    </Link>
  );
};
